// TrumpetVSCO2.js
// COMPREHENSIVE HIGH QUALITY Trumpet from VSCO2 Community Edition
// License: CC BY 4.0
// All articulations with proper velocity layers
// Tone.js will interpolate between these samples for perfect pitch

// ==========================================
// STACCATO (11 notes, 3 velocity layers)
// ==========================================
export const TRUMPET_VSCO2_STACCATO_SOFT = {
    "A#3": "As3_soft.mp3",
    A2: "A2_soft.mp3",
    A4: "A4_soft.mp3",
    C3: "C3_soft.mp3",
    C5: "C5_soft.mp3",
    "D#3": "Ds3_soft.mp3",
    D4: "D4_soft.mp3",
    F2: "F2_soft.mp3",
    F3: "F3_soft.mp3",
    F4: "F4_soft.mp3",
    G3: "G3_soft.mp3"
};

export const TRUMPET_VSCO2_STACCATO_MEDIUM = {
    "A#3": "As3_medium.mp3",
    A2: "A2_medium.mp3",
    A4: "A4_medium.mp3",
    C3: "C3_medium.mp3",
    C5: "C5_medium.mp3",
    "D#3": "Ds3_medium.mp3",
    D4: "D4_medium.mp3",
    F2: "F2_medium.mp3",
    F3: "F3_medium.mp3",
    F4: "F4_medium.mp3",
    G3: "G3_medium.mp3"
};

export const TRUMPET_VSCO2_STACCATO_LOUD = {
    "A#3": "As3_loud.mp3",
    A2: "A2_loud.mp3",
    A4: "A4_loud.mp3",
    C3: "C3_loud.mp3",
    C5: "C5_loud.mp3",
    "D#3": "Ds3_loud.mp3",
    D4: "D4_loud.mp3",
    F2: "F2_loud.mp3",
    F3: "F3_loud.mp3",
    F4: "F4_loud.mp3",
    G3: "G3_loud.mp3"
};

export const TRUMPET_VSCO2_STACCATO = TRUMPET_VSCO2_STACCATO_MEDIUM;

// ==========================================
// SUSTAIN (10 notes, 2 velocity layers: v1=soft, v3=loud)
// ==========================================
export const TRUMPET_VSCO2_SUSTAIN_SOFT = {
    "A#3": "As3_soft.mp3",
    A2: "A2_soft.mp3",
    A4: "A4_soft.mp3",
    C3: "C3_soft.mp3",
    C5: "C5_soft.mp3",
    "D#3": "Ds3_soft.mp3",
    D4: "D4_soft.mp3",
    F2: "F2_soft.mp3",
    F4: "F4_soft.mp3",
    G3: "G3_soft.mp3"
};

export const TRUMPET_VSCO2_SUSTAIN_LOUD = {
    "A#3": "As3_loud.mp3",
    A2: "A2_loud.mp3",
    A4: "A4_loud.mp3",
    C3: "C3_loud.mp3",
    C5: "C5_loud.mp3",
    "D#3": "Ds3_loud.mp3",
    D4: "D4_loud.mp3",
    F2: "F2_loud.mp3",
    F4: "F4_loud.mp3",
    G3: "G3_loud.mp3"
};

export const TRUMPET_VSCO2_SUSTAIN = TRUMPET_VSCO2_SUSTAIN_SOFT;

// ==========================================
// SUSTAIN VIBRATO (11 notes, 2 velocity layers: v1=soft, v2=medium)
// ==========================================
export const TRUMPET_VSCO2_SUSVIB_SOFT = {
    "A#3": "As3_soft.mp3",
    A2: "A2_soft.mp3",
    A4: "A4_soft.mp3",
    C3: "C3_soft.mp3",
    C5: "C5_soft.mp3",
    "D#3": "Ds3_soft.mp3",
    D4: "D4_soft.mp3",
    F2: "F2_soft.mp3",
    F3: "F3_soft.mp3",
    F4: "F4_soft.mp3",
    G3: "G3_soft.mp3"
};

export const TRUMPET_VSCO2_SUSVIB_MEDIUM = {
    "A#3": "As3_medium.mp3",
    A2: "A2_medium.mp3",
    A4: "A4_medium.mp3",
    C3: "C3_medium.mp3",
    C5: "C5_medium.mp3",
    "D#3": "Ds3_medium.mp3",
    D4: "D4_medium.mp3",
    F2: "F2_medium.mp3",
    F3: "F3_medium.mp3",
    F4: "F4_medium.mp3",
    G3: "G3_medium.mp3"
};

export const TRUMPET_VSCO2_SUSVIB = TRUMPET_VSCO2_SUSVIB_SOFT;

// ==========================================
// HARMON MUTE SUSTAIN (8 notes, 2 velocity layers: v1=soft, v3=loud)
// ==========================================
export const TRUMPET_VSCO2_HARMON_MUTE_SOFT = {
    "A#2": "As2_soft.mp3",
    "A#3": "As3_soft.mp3",
    A4: "A4_soft.mp3",
    C3: "C3_soft.mp3",
    "D#3": "Ds3_soft.mp3",
    D4: "D4_soft.mp3",
    F4: "F4_soft.mp3",
    "G#3": "Gs3_soft.mp3"
};

export const TRUMPET_VSCO2_HARMON_MUTE_LOUD = {
    "A#2": "As2_loud.mp3",
    "A#3": "As3_loud.mp3",
    A4: "A4_loud.mp3",
    C3: "C3_loud.mp3",
    "D#3": "Ds3_loud.mp3",
    D4: "D4_loud.mp3",
    F4: "F4_loud.mp3",
    "G#3": "Gs3_loud.mp3"
};

export const TRUMPET_VSCO2_HARMON_MUTE = TRUMPET_VSCO2_HARMON_MUTE_SOFT;

// ==========================================
// STRAIGHT MUTE SUSTAIN (8 notes, 2 velocity layers: v1=soft, v3=loud)
// ==========================================
export const TRUMPET_VSCO2_STRAIGHT_MUTE_SOFT = {
    "A#2": "As2_soft.mp3",
    "A#3": "As3_soft.mp3",
    A4: "A4_soft.mp3",
    C3: "C3_soft.mp3",
    D3: "D3_soft.mp3",
    D4: "D4_soft.mp3",
    F4: "F4_soft.mp3",
    G3: "G3_soft.mp3"
};

export const TRUMPET_VSCO2_STRAIGHT_MUTE_LOUD = {
    "A#2": "As2_loud.mp3",
    "A#3": "As3_loud.mp3",
    A4: "A4_loud.mp3",
    C3: "C3_loud.mp3",
    D3: "D3_loud.mp3",
    D4: "D4_loud.mp3",
    F4: "F4_loud.mp3",
    G3: "G3_loud.mp3"
};

export const TRUMPET_VSCO2_STRAIGHT_MUTE = TRUMPET_VSCO2_STRAIGHT_MUTE_SOFT;

// ==========================================
// ARTICULATION MAPPINGS (for smart sampler)
// ==========================================
export const TRUMPET_VSCO2_ARTICULATIONS = {
    staccato: TRUMPET_VSCO2_STACCATO,
    sustain: TRUMPET_VSCO2_SUSTAIN,
    susvib: TRUMPET_VSCO2_SUSVIB,
    harmonMute: TRUMPET_VSCO2_HARMON_MUTE,
    straightMute: TRUMPET_VSCO2_STRAIGHT_MUTE
};

// Default export (for backward compatibility)
export const TRUMPET_VSCO2 = TRUMPET_VSCO2_STACCATO;
